<template>
  <div>
    <div class="p-4 pb-0">
      <span class="p-1 rounded-lg border border-gray-200 hover:bg-gray-50 duration-100 ease-in-out inline-block text-gray-500 cursor-pointer active:scale-110" @click="show = true">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
        </svg>
      </span>
    </div>

    <portal v-if="mounted" to="settings-root">
      <Settings :show="show" @close="show = false"/>
    </portal>
  </div>
</template>

<script>

import Settings from "./Settings"

export default {
  components: {
    Settings,
  },
  mounted() {
    this.mounted = true
  },
  data() {
    return {
      mounted: false,
      show: false,
    }
  }
}

</script>
